<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [class]="showAuditDetails ? 'd-none' : ''"
  [config]="pageConfig"
  (onClose)="onHidePage()"
  (onRefresh)="onReset()"
  (sortObject)="getSortItems($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowHelpPage)="onShowHelpPage()"
>
  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- userId -->
        <!-- <td>
          <td-value copyToClipboard [value]="item?.customFields?.userInfo?.userId"></td-value>
        </td> -->
        <!-- userName -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.document?.userInfo?.userName"
          ></td-value>
        </td>
        <!-- referenceId -->
        <td *ngIf="!hideReferenceId">
          <td-value
            copyToClipboard
            [value]="item?.document?.referenceId"
          ></td-value>
        </td>
        <td *ngIf="methodName == 'blackListsGetBlackListAudits'">
          <td-value
            copyToClipboard
            [value]="item?.document?.target?.New[0]?.Mobile"
          ></td-value>
        </td>
        <!-- operationType -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.document?.operationType"
          ></td-value>
        </td>
        <!-- comments -->
        <td tw-text-center tw-cursor-pointer>
          <app-expand-text [placement]="'right'">
            <span small-text class="text-gray tw-text-sm" copyToClipboard>{{
              item?.document?.comments
            }}</span>
            <div full-text class="full-text-display tw-w-[250px]">
              {{ item?.document?.comments }}
            </div>
          </app-expand-text>
        </td>
        <!-- startDate -->
        <td>
          <td-value
            type="dateTime"
            [value]="item?.document?.startDate"
          ></td-value>
        </td>

        <!-- endDate -->
        <td>
          <td-value
            type="dateTime"
            [value]="item?.document?.endDate"
          ></td-value>
        </td>

        <!-- detail -->
        <td class="sticky-td">
          <a
            (click)="onDetail(item)"
            class="btn btn-sm tw-ml-3"
            matTooltip="{{ 'common.showDetails' | translate }}"
          >
            <i class="mdi mdi-text-box-search-outline mdi-20px text-info"></i>
          </a>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- Audit -->
<ng-container *ngIf="showAuditDetails">
  <app-audit-detail
    [model]="auditDetailsModel"
    (closePage)="onCloseDetail($event)"
  ></app-audit-detail>
</ng-container>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
